import { defineSseEvent } from '@terra/shared-sse-contracts';
import { TargetTypeSchema } from '@terra/shared-schemas-orchestrator';
import { z } from 'zod';

export const APPLICATION_DISCOVERY_STATUS_CHANGED_SSE_TYPE =
  'APPLICATION_DISCOVERY_STATUS_CHANGED' as const;

export const ApplicationDiscoveryStatusSchema = z.enum([
  'idle',
  'discovering',
  'queued',
  'processing',
  'deduplicating',
]);

export type ApplicationDiscoveryStatus = z.infer<
  typeof ApplicationDiscoveryStatusSchema
>;

export const ApplicationDiscoveryStatusChangedSsePayloadSchema = z.object({
  applicationId: z.string(),
  status: ApplicationDiscoveryStatusSchema,
  targetId: z.string(),
  targetType: TargetTypeSchema,
  dueAt: z.number().optional(),
});

export const APPLICATION_DISCOVERY_STATUS_CHANGED_SSE_EVENT = defineSseEvent({
  type: APPLICATION_DISCOVERY_STATUS_CHANGED_SSE_TYPE,
  payload: ApplicationDiscoveryStatusChangedSsePayloadSchema,
  channelPrefix: 'application-discovery-status',
  channelKey: ({ applicationId }) => applicationId,
  target: {
    type: (payload) => payload.targetType,
    id: (payload) => payload.targetId,
  },
});

export type ApplicationDiscoveryStatusChangedSsePayload = z.infer<
  typeof ApplicationDiscoveryStatusChangedSsePayloadSchema
>;

export const ApplicationDiscoveryStatusResponseSchema = z.object({
  status: ApplicationDiscoveryStatusSchema,
  dueAt: z.number().optional(),
});

export type ApplicationDiscoveryStatusResponse = z.infer<
  typeof ApplicationDiscoveryStatusResponseSchema
>;
